import { useCallback } from 'react';

export const useFileUploadState = ({
  setFilesToUpload,
  setFilesLoaded,
  setToastState,
  setDropboxFile,
  inputRefsMap
}) => {
  const handleUploadSuccess = useCallback(
    (uploadData) => {
      const { filename, fileType, temporalFileName } = uploadData;

      setFilesToUpload({
        type: 'uploaded',
        filename,
        fileType
      });

      setFilesLoaded({
        fileType,
        filename,
        uploadedBy: 'user',
        temporalFileName,
        buttonUploader: ''
      });
    },
    [setFilesToUpload, setFilesLoaded]
  );

  const handleUploadPending = useCallback(
    (uploadData) => {
      const { filename, fileType, buttonUploader } = uploadData;

      setFilesToUpload({
        type: 'uploading',
        filename,
        fileType,
        buttonUploader
      });
    },
    [setFilesToUpload]
  );

  const handleUploadError = useCallback(
    (error) => {
      const { fileType } = error;

      if (inputRefsMap.current[fileType]) {
        inputRefsMap.current[fileType].value = '';
      }

      setFilesToUpload({ type: 'idle', filename: '', fileType });

      setToastState({ visible: false, type: '', message: '' });
      setToastState({
        visible: true,
        type: 'error',
        message: error.message
      });
    },
    [setToastState]
  );

  const handleDropboxSuccess = useCallback(
    ({ fileContent, fileType }, handleChange) => {
      handleChange({
        inputFilename: fileType,
        buttonUploader: 'dropbox',
        fileContent
      });
      setDropboxFile({ name: '', url: null, fileType: '' });
    },
    [setDropboxFile]
  );

  return {
    handleUploadSuccess,
    handleUploadError,
    handleDropboxSuccess,
    handleUploadPending
  };
};
